import notify from '@/api/notification'
import billings from '@/api/billings'

const state = {
  billingsList: [],
  isLoadingBillings: false,
  billingsTotalPages: 1
}

const mutations = {
  updateBillingsList(state, data) {
    state.billingsList = data
  },
  setBillingsLoadingStatus(state, status) {
    state.isLoadingBillings = status
  },
  updateBillingsTotalPages(state, total) {
    state.billingsTotalPages = total
  }
}

const getters = {
  billingsList: state => {
    return state.billingsList
  },
  isLoadingBillings: state => {
    return state.isLoadingBillings
  },
  billingsTotalPages: state => {
    return state.billingsTotalPages
  }
}

const actions = {
  getInvoiceList: ({ commit }, data) => {
    commit('setBillingsLoadingStatus', true)
    return billings
      .getInvoiceList(data.page, data.referenceDate)
      .then(res => {
        const list = state.billingsList.concat(res.data.invoice)
        commit('updateBillingsList', list)
        commit('setBillingsLoadingStatus', false)
        commit('updateBillingsTotalPages', res.data.totalPages)
      })
      .catch(err => {
        commit('setBillingsLoadingStatus', false)
        if (err.status !== 404) {
          notify({
            title: 'AVISO: ',
            message: 'Erro ao carregar lista de faturas.'
          })
        }
        console.error('err -->', err)
      })
  },
  cleanInvoiceList: ({ commit }) => {
    commit('updateBillingsList', [])
    commit('updateBillingsTotalPages', 1)
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
